// extracted by mini-css-extract-plugin
export default {"passportDownloadItem":"PassportDownloadItem_passportDownloadItem__e7tcD"};